import { css } from '@/styled-system/css';

export const wrapperRelative = css({
  position: 'relative',
  display: 'none',
  lg: {
    display: 'block',
  },
});

export const tealFrame = css({
  backgroundColor: 'brand.primary',
  borderRadius: 'sm',
  padding: 'loose',
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

export const innerCard = css({
  backgroundColor: 'bg.neutral',
  borderRadius: 'sm',
});
